import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { bindAll } from '@bibliocommons/utils-react';
import { DefaultButton } from '@bibliocommons/deprecated-base-buttons';
import { Lock, Unlock } from '@bibliocommons/deprecated-base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import './PrivacyTogglePills.scss';

class PrivacyTogglePills extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleToggleClick(isPrivate) {
    if (this.props.isPrivate === isPrivate) {
      return;
    }

    this.props.handlePrivacyToggle(isPrivate);
  }

  render() {
    const { isPrivate } = this.props;
    return (
      <div className="cp-privacy-toggle-pills">
        <ScreenReaderMessage aria-live="polite">
          {isPrivate ? <FormattedMessage id="item_is_private" /> : <FormattedMessage id="item_is_shared" />}
        </ScreenReaderMessage>
        <DefaultButton
          className={cn('privacy-toggle-btn', 'lock', { selected: isPrivate })}
          handleClick={() => this.handleToggleClick(true)}
          aria-label={this.props.intl.formatMessage({
            id: 'change_item_privacy_to_private'
          })}
        >
          <Lock />
        </DefaultButton>
        <DefaultButton
          className={cn('privacy-toggle-btn', 'unlock', {
            selected: !isPrivate
          })}
          handleClick={() => this.handleToggleClick(false)}
          aria-label={this.props.intl.formatMessage({
            id: 'change_item_privacy_to_shared'
          })}
        >
          <Unlock />
        </DefaultButton>
      </div>
    );
  }
}

const injectIntlPropTypes = {};

PrivacyTogglePills.propTypes = {
  isPrivate: PropTypes.bool.isRequired,
  handlePrivacyToggle: PropTypes.func.isRequired,
  ...injectIntlPropTypes
};

PrivacyTogglePills.displayName = 'PrivacyTogglePills';

export default injectIntl(PrivacyTogglePills);
